import React, { useState } from "react";
import ProfileBox from "../components/Box/ProfileBox";
import ProfileContainer from "../components/Container/ProfileContainer";
import EditProfile from "../components/Forms/EditProfile";
import Navbar from "./Navbar";
import { MdOutlinePayment } from "react-icons/md";
import { AiOutlineProfile } from "react-icons/ai";
import { GoLocation } from "react-icons/go";
import useAuth from "../hooks/useAuth";

const Profile = () => {
  const { user } = useAuth();

  const [showEditProfileModal, setShowEditProfileModal] = useState(false);

  const toggleEditModal = () => {
    setShowEditProfileModal(!showEditProfileModal);
  };

  return (
    <>
      <Navbar />
      <div className="w-full relative">
        <div className="relative lg:px-12 md:px-8 px-0 w-full lg:py-5 md:py-4 py-2 bg-slate-50">
          <h1 className="text-xl font-bold md:px-8 px-4 py-4">My Account </h1>

          <>
            <div className="flex w-full justify-evenly">
              <div className="border w-full md:basis-5/12  ">
                <div className="  border-gray-200 rounded-sm bg-white shadow-sm lg:p-5 md:p-4 px-2 py-4">
                  <ProfileBox user={user} />

                  <div className="grid grid-cols-2 gap-2 py-2 ">
                    <div className="w-full">
                      <button className="w-full text-center border text-sm font-semibold bg-white hover:bg-rose-50 border-rose-400 transition-colors duration-100  text-rose-500  py-2 rounded-sm">
                        <MdOutlinePayment className="inline text-xl mr-2 text-rose-500" />{" "}
                        Payment Methods{" "}
                      </button>
                    </div>
                    <div className="w-full">
                      <button className="w-full text-center border text-sm font-semibold bg-white hover:bg-rose-50 border-rose-400 transition-colors duration-100  text-rose-500  py-2 rounded-sm">
                        <AiOutlineProfile className="inline text-xl mr-2 text-rose-500" />
                        Order History{" "}
                      </button>
                    </div>
                    <div className="col-span-2">
                      <button className="w-full  text-center border text-sm font-semibold bg-white hover:bg-rose-50 border-rose-400 transition-colors duration-100  text-rose-500 py-2 rounded-sm">
                        <GoLocation className="inline text-xl mr-2 text-rose-500" />{" "}
                        Delivery Adress
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="basis-6/12 hidden md:block bg-white border border-gray-200 rounded-sm shadow-sm lg:p-5 md:p-4 p-2">
                <div className="flex justify-between items-center mb-4 ">
                  <h1 className="text-lg font-semibold ">
                    Account Information
                  </h1>
                  <h1>
                    <button
                      onClick={toggleEditModal}
                      className="text-md font-medium text-rose-500 hover:cursor-pointer"
                    >
                      Edit
                    </button>
                  </h1>
                </div>

                <div className="grid grid-cols-2 px-2 mb-5">
                  <div>
                    <h1 className="text-gray-400 text-xs font-semibold mb-1">
                      Full Name
                    </h1>
                    <h1 className="text-sm font-semibold">
                      {user ? user.fullname : "Unknown"}
                    </h1>
                  </div>
                  <div>
                    <h1 className="text-gray-400 text-xs font-semibold mb-1">
                      Mobile Number
                    </h1>
                    <h1 className="text-sm font-semibold">
                      {user ? user.phone : "Unknown"}
                    </h1>
                  </div>
                </div>

                <div className="grid grid-cols-2 px-2 mb-0">
                  <div>
                    <h1 className="text-gray-400 text-xs font-semibold mb-1">
                      Email id
                    </h1>
                    <h1 className="text-sm font-semibold">
                      {user ? user.email : "Unknown"}
                    </h1>
                  </div>
                  <div>
                    <h1 className="text-gray-400 text-xs font-semibold mb-1">
                      Default Address
                    </h1>
                    <h1 className="text-sm font-semibold">
                      {user && user.address
                        ? user.address.size > 0
                          ? user.address[0]
                          : "Unknown"
                        : "Unknown"}
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex w-full lg:ml-8 py-4">
              <div className="md:basis-5/12 w-full  border px-4 py-4 border-gray-200 shadow-sm rounded-sm bg-white ">
                <div className="w-full">
                  <a
                    href="/alloffers"
                    className="text-sm font-semibold text-gray-700 py-4 block border border-transparent border-b-gray-200"
                  >
                    My List
                  </a>
                </div>
                <div className="w-full">
                  <a
                    href="/alloffers"
                    className="text-sm font-semibold text-gray-700 py-4 block border border-transparent border-b-gray-200"
                  >
                    Wish List
                  </a>
                </div>
                <div className="w-full">
                  <a
                    href="/alloffers"
                    className="text-sm font-semibold text-gray-700 py-4 block border border-transparent border-b-gray-200"
                  >
                    Legal Information
                  </a>
                </div>
                <div className="w-full">
                  <a
                    href="/alloffers"
                    className="text-sm font-semibold text-gray-700 py-4 block border border-transparent border-b-gray-200"
                  >
                    Need Help
                  </a>
                </div>
                <div className="w-full">
                  <a
                    href="/alloffers"
                    className="text-sm font-semibold text-gray-700 py-4 block border border-transparent border-b-gray-200"
                  >
                    Contact Us
                  </a>
                </div>
                <div className="w-full">
                  <a
                    href="/alloffers"
                    className="text-sm font-semibold text-gray-700 py-4 block "
                  >
                    Logout
                  </a>
                </div>
              </div>
            </div>
          </>
        </div>

        {showEditProfileModal && (
          <EditProfile toggleEditModal={toggleEditModal} user={user} />
        )}
      </div>
    </>
  );
};


export default Profile;
